"use strict";
var Ajaxinate = function (t) {
	var e = t || {};
	this.settings = Object.assign({ pagination: "#AjaxinatePagination", method: "scroll", container: "#AjaxinateLoop", offset: 0, loadingText: "Loading", callback: null }, e);
	this.addScrollListeners = this.addScrollListeners.bind(this);
	this.addClickListener = this.addClickListener.bind(this);
	this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
	this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
	this.destroy = this.destroy.bind(this);
	this.containerElement = document.querySelector(this.settings.container);
	this.paginationElement = document.querySelector(this.settings.pagination);
	this.initialize();
};

Ajaxinate.prototype.initialize = function () {
	if (this.containerElement) {
		({ click: this.addClickListener, scroll: this.addScrollListeners }[this.settings.method]());
	}
};

Ajaxinate.prototype.addScrollListeners = function () {
	if (this.paginationElement) {
		document.addEventListener("scroll", this.checkIfPaginationInView);
		window.addEventListener("resize", this.checkIfPaginationInView);
		window.addEventListener("orientationchange", this.checkIfPaginationInView);
	}
};

Ajaxinate.prototype.addClickListener = function () {
	if (this.paginationElement) {
		this.nextPageLinkElement = this.paginationElement.querySelector("a");
		this.clickActive = true;
		if (this.nextPageLinkElement !== null) {
			this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks);
		}
	}
};

Ajaxinate.prototype.stopMultipleClicks = function (t) {
	t.preventDefault();
	if (this.clickActive) {
		this.nextPageLinkElement.innerHTML = this.settings.loadingText;
		this.nextPageUrl = this.nextPageLinkElement.href;
		this.clickActive = false;
		this.loadMore();
	}
};

// Ajaxinate.prototype.checkIfPaginationInView = function () {
//     var t = this.paginationElement.getBoundingClientRect().top - this.settings.offset;
//     var e = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
//     if (t <= window.innerHeight && e >= 0) {
//       this.nextPageLinkElement = this.paginationElement.querySelector("a");
//       this.removeScrollListener();
//       if (this.nextPageLinkElement) {
//         this.nextPageLinkElement.innerHTML = this.settings.loadingText;
//         this.nextPageUrl = this.nextPageLinkElement.href;
//         this.loadMore();
//       }
//     }
// };

Ajaxinate.prototype.checkIfPaginationInView = function () {
	if (!this.paginationElement) return;

	const rect = this.paginationElement.getBoundingClientRect();
	const triggerPoint = window.innerHeight + 900;

	if (rect.top <= triggerPoint) {
		this.nextPageLinkElement = this.paginationElement.querySelector("a");
		this.removeScrollListener();

		if (this.nextPageLinkElement) {
			this.nextPageLinkElement.innerHTML = this.settings.loadingText;
			this.nextPageUrl = this.nextPageLinkElement.href;
			this.loadMore();
		}
	}
};

Ajaxinate.prototype.loadMore = function () {
	this.request = new XMLHttpRequest;
	this.request.onreadystatechange = function () {
		if (this.request.readyState === 4 && this.request.status === 200) {
			var t = this.request.responseXML.querySelectorAll(this.settings.container)[0];
			var e = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];
			this.containerElement.insertAdjacentHTML("beforeend", t.innerHTML);

			if (document.querySelectorAll('#product-grid .grid-item').length) {
				document.querySelectorAll('#product-grid .grid-item').forEach((item) => {
					item.classList.remove('hidden')
				})
			}

			this.paginationElement.innerHTML = e.innerHTML;
			if (this.settings.callback && typeof this.settings.callback == "function") {
				this.settings.callback(this.request.responseXML);
			}
			this.initialize();
		}
	}.bind(this);
	this.request.open("GET", this.nextPageUrl);
	this.request.responseType = "document";
	this.request.send();
};

Ajaxinate.prototype.removeClickListener = function () {
	this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks);
};

Ajaxinate.prototype.removeScrollListener = function () {
	document.removeEventListener("scroll", this.checkIfPaginationInView);
	window.removeEventListener("resize", this.checkIfPaginationInView);
	window.removeEventListener("orientationchange", this.checkIfPaginationInView);
};

Ajaxinate.prototype.destroy = function () {
	({ click: this.removeClickListener, scroll: this.removeScrollListener }[this.settings.method]());
	return this;
};